import { createEnumParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

import { CompanyReadModelSort, SortOrder } from '@client/api';

export const useCompanyListSearchQueryParams = () => {
  const result = useQueryParams({
    companiesSearch: StringParam,
  });

  return result;
};

export const useCompanyListSortQueryParams = () => {
  const result = useQueryParams({
    companiesSortProperty: withDefault<CompanyReadModelSort | undefined | null, CompanyReadModelSort>(
      createEnumParam(['Name', 'VatId']),
      'Name'
    ),
    companiesSortOrder: withDefault<SortOrder | undefined | null, SortOrder>(createEnumParam(['Asc', 'Desc']), 'Asc'),
  });

  return result;
};
